import './App.css';
import  "../node_modules/bootstrap/dist/css/bootstrap.min.css"
import ClientDocuments from './pages/ClientDocuments/ClientDocuments';
import  "./index.css"
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from './pages/Authentication/Login';
import CreatePassword from './pages/CreatePassword/CreatePassword';
import Orderlist from './pages/OrderList/Orderlist';
import OrderSummaryDetails from './pages/OrderSummayDetails/OrderSummaryDetails';
import TravelItineraryMain from './pages/TravelItineraryMain/TravelItineraryMain';
import ScopeOfWorkMain from './pages/ScopeOfWorkMain/ScopeOfWorkMain';
import CustomerProfile from './pages/CustomerProfile/CustomerProfile';
import PetProfile from './pages/PetProfile/PetProfile';
import TestItinerary from './components/TestItineraryPDF/TestItineraryPDF';
import ChangePassword from './pages/ChangePassword/ChangePassword';
import MobileViewProfileMenu from './pages/MobileViewProfileMenu/MobileViewProfileMenu';
import Quotation from './pages/Quotation/Quotation';
import BookingForm from './pages/BookingForm/BookingForm';
import BillingDetails from './pages/AccountsBillingDetails/AccountsBillingDetails';

function App() {
  return (
    <Router> 
      <Routes>
        <Route path="/" element={<Login/>} />
        <Route path="/createPassword" element={<CreatePassword/>} />
        <Route path="/profileMenu" element={<MobileViewProfileMenu/>} />
        <Route path='/customerProfile' element={<CustomerProfile/>}/>
        <Route path='/petProfile' element={<PetProfile/>}/>
        <Route path='/changePassword' element={<ChangePassword/>}/>
        <Route path="/orderlist" element={<Orderlist/>} />
        <Route path="/orderSummary" element={<OrderSummaryDetails/>} />
        <Route path="/travelItinerary" element={<TravelItineraryMain/>} />
        <Route path="/scopeOfWork" element={<ScopeOfWorkMain/>} />
        <Route path="/quotation" element={<Quotation/>} />
        <Route path="/ClientDocuments" element={<ClientDocuments />} />
        <Route path='/testPDF' element={<TestItinerary/>}/>
        <Route path="/BookingForm" element={<BookingForm/>} />
        <Route path="/billingDetails" element={<BillingDetails/>} />
      </Routes>
    </Router>
  );
}

export default App;
